import request from '@/utils/request'

export const getCentres = (params: any) =>
  request({
    url: '/centres',
    method: 'get',
    params
  })
